<template>
      <div id="choose-plan">
            <section class="section choose-plan-hero animate__animated animate__fadeIn">
                  <BackButton link="/checklist" />
                  <div class="grid-container max">
                        <div class="choose-plan-grid">
                              <div class="choose-plan-left">
                                    <h1>Choose a plan<br />that&rsquo;s all<br />about you</h1>
                              </div>
                              <div class="choose-plan-right">
                                    <p class="choose-plan-heading">What&rsquo;s the difference between Anthem&rsquo;s HMO and HRA plan options?</p>
                                    <p class="choose-plan-desc"><strong>Anthem&rsquo;s HMO</strong>, or <strong>Health Maintenance Organization</strong>, is a Plan Option that offers access to in-network providers only, who have agreed to accept negotiated rates for covered services provided. It offers set co-pays for certain covered services and doesn&rsquo;t require a referral to see a specialist.</p>
                                    <p class="choose-plan-desc"><strong>Anthem&rsquo;s HRA</strong>, or <strong>Health Reimbursement Arrangement</strong>, offers the same benefits you would receive from a typical health plan, plus healthcare credits to help offset your out-of-pocket expenses. SHBP sets up an HRA account for you and deposits base credits determined by the HRA Plan Option you choose.</p>
                                    <div class="choose-plan-card light">
                                          <h5>HRA Gold, Silver and Bronze</h5>
                                          <p>Anthem&rsquo;s HRA plans are designed to accommodate a range of financial and health goals. There are three levels of Anthem HRA Plan Options that have different base credits, deductibles, co-insurance levels, and out-of-pocket maximums.</p>
                                    </div>
                                    <div class="choose-plan-card dark">
                                          <h5>An HMO might be the best choice if:</h5>
                                          <ul>
                                                <li>Your doctors are in-network</li>
                                                <li>You prefer to pay set co-pays for certain services</li>
                                          </ul>
                                          <h5>An HRA might be best for you if:</h5>
                                          <ul>
                                                <li>You want the option for both in- and out-of-network coverage</li>
                                                <li>You want a base fund of credits from SHBP to help offset healthcare costs</li>
                                          </ul>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="choose-plan-btn-wrap">
                        <router-link to="/plan-options" class="choose-plan-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      export default {
            name: "SHBPChoosePlan",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            }
      }
</script>

<style lang="scss">
#choose-plan {
      .choose-plan-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .choose-plan-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .choose-plan-left {
                  flex: 1 1 400px;
                  max-width: 540px;
                  position: sticky;
                  top: 140px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .choose-plan-right {
                  flex: 1 1 480px;
                  max-width: 620px;
                  min-width: 0;

                  .choose-plan-heading {
                        color: #012E58;
                        font-size: 1.375rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 20px;
                  }

                  .choose-plan-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 20px;

                        strong {
                              color: #12130f;
                              font-weight: 700;
                        }
                  }

                  .choose-plan-card {
                        padding: 24px;
                        margin-top: 24px;

                        &.light {
                              background-color: #F4F5F7;

                              h5 {
                                    color: #1355E9;
                                    font-weight: 700;
                                    font-size: 1.0625rem;
                                    margin-bottom: 8px;
                              }

                              p {
                                    color: #3F3A4E;
                                    font-size: 0.9375rem;
                                    line-height: 1.6;
                                    margin-bottom: 0;
                              }
                        }

                        &.dark {
                              background-color: #0A2C4C;

                              h5 {
                                    color: #ffffff;
                                    font-weight: 700;
                                    font-size: 1.0625rem;
                                    margin-bottom: 8px;
                              }

                              ul {
                                    margin: 0 0 20px 1.125rem;
                                    padding: 0;

                                    li {
                                          color: rgba(255, 255, 255, 0.9);
                                          font-size: 0.9375rem;
                                          line-height: 1.6;
                                    }
                              }

                              h5:last-of-type {
                                    margin-top: 0;
                              }

                              ul:last-child {
                                    margin-bottom: 0;
                              }
                        }
                  }
            }

            .choose-plan-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .choose-plan-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .choose-plan-grid {
                        flex-direction: column;
                        gap: 32px;
                        margin-top: 32px;
                  }

                  .choose-plan-left {
                        flex: 0 0 auto;
                        max-width: 100%;
                        position: static;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .choose-plan-right {
                        flex: 0 0 auto;
                        max-width: 100%;
                  }
            }
      }
}
</style>
